import { render } from "./UserList.vue?vue&type=template&id=50707e77&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=50707e77&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50707e77"

export default script